// extracted by mini-css-extract-plugin
module.exports = {"noBorder":"table_noBorder__tmcP8","listitem":"table_listitem__3avgv","tableitem":"table_tableitem__IWnj1","gridlist":"table_gridlist__2gjN1"};